import { createSlice } from "@reduxjs/toolkit";
import { retrieveReviewsAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const retrieveReviewsSlice = createSlice({
  name: "retrieveReviews",
  initialState: data,
  reducers: {
    retrieveReviewsSlice(state) {
      state.isLoading = true;
    },
    retrieveReviewsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    retrieveReviewsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    retrieveReviewsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const retrieveReviewsHandler = (org_id:string) => async (dispatch: any) => {
  try {
    dispatch(retrieveReviewsAction.retrieveReviewsSlice());
    const response: any = await retrieveReviewsAPI(org_id);
    dispatch(retrieveReviewsAction.retrieveReviewsSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(retrieveReviewsAction.retrieveReviewsSliceFailure(e?.response?.data?.message));
    dispatch(retrieveReviewsAction.retrieveReviewsSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default retrieveReviewsSlice.reducer;
export const retrieveReviewsAction = retrieveReviewsSlice.actions;
